import { fromJS } from 'immutable';
import { fromMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import { getMetricsFromMetricsEditorReportConfig } from 'reporting-enablement/components/reportEditors/MetricEditor/metricEditorUtils';
import { NUMBER_OF_REPORTS_IN_CAROUSEL } from './constants';
export const convertReportMetricToConfigReportMetric = metric => fromJS(Object.assign({
  property: metric.property,
  metricTypes: [metric.metricType]
}, metric.percentiles ? {
  percentiles: metric.percentiles
} : {}));
export const getMetricsFromMetricEditor = report => getMetricsFromMetricsEditorReportConfig(report).map(metric => {
  const {
    property,
    type
  } = fromMetricKey(metric);
  return fromJS({
    property,
    metricTypes: [type]
  });
});
export const splitMetricsIntoGroups = (allMetrics, baseDatawellReport) => {
  return new Array(Math.ceil(allMetrics.size / NUMBER_OF_REPORTS_IN_CAROUSEL)).fill(0).map((_, index) => {
    const startIndex = index * NUMBER_OF_REPORTS_IN_CAROUSEL;
    const endIndex = startIndex + NUMBER_OF_REPORTS_IN_CAROUSEL;
    const metrics = allMetrics.slice(startIndex, endIndex);
    return baseDatawellReport.setIn(['config', 'metrics'], metrics);
  });
};

// these are "wildcard" metric properties that map to multiple kpis in the viz
const NON_1_TO_1_METRICS = ['dealstages.*_duration', 'ticketstatus.*_duration'];
export const filterUnsupportedMetricsFromLimit = (metrics, kpiLimit) => {
  if (kpiLimit === 1) {
    return metrics.filterNot(metric => NON_1_TO_1_METRICS.includes(metric.get('property')));
  }
  return metrics;
};